import * as Sentry from "@sentry/react"
import { createRootRoute, Outlet } from "@tanstack/react-router"

import { ErrorBoundary, PopUpPermission } from "@/components/shared"
import { LoadingPage } from "@/components/shared/ui/loading-page"
import { useTokenSync } from "@/modules/helpers/hooks/shared"

function RootComponent() {
  // Initialize token sync with native app
  useTokenSync()

  return (
    <>
      <PopUpPermission />
      <Outlet />
    </>
  )
}

function RootErrorComponent({ error }: { error: Error }) {
  // Report to Sentry in production
  if (import.meta.env.MODE === "production") {
    Sentry.captureException(error)
  }
  return <ErrorBoundary error={error} />
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RootErrorComponent,
  pendingComponent: () => <LoadingPage />
})
